/* eslint-disable react-hooks/exhaustive-deps */
import { connect } from "react-redux";
import { setAgentsProfilesList } from "../../redux/actions";
import AgentProfileComponent from "../../components/AgentsProfiles/AgentProfileComponent"
const mapStateToProps = (state, props) => {
    return {
      AgentsProfilesList: state?.AgentsProfilesList,
    };
};
const mapDispatchToProps = (dispatch) => ({
   setAgentsProfilesList: (AgentsProfilesList) =>
      dispatch(setAgentsProfilesList(AgentsProfilesList)),
  });
export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(AgentProfileComponent);
